import { all, takeEvery, put, call } from 'redux-saga/effects'
import { getMenuDataByUsuarioId } from 'services/menu.service'
import { actions } from './actions'

/*
export function* GET_DATA() {
  const menuData = yield call(getMenuData)
  yield put({
    type: 'menu/SET_STATE',
    payload: {
      menuData,
    },
  })
}
*/

export function* GET_DATA_BY_USUARIO_ID(action) {
  const menuData = yield call(getMenuDataByUsuarioId, action.payload)
  yield put({
    type: 'menu/SET_STATE',
    payload: {
      menuData,
    },
  })
}

export default function* rootSaga() {
  yield all([
    // GET_DATA(), // run once on app load to fetch menu data
    takeEvery(actions.GET_DATA, GET_DATA_BY_USUARIO_ID),
  ])
}
